import React from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  useCurrentUserArchivedReadingListItemsQuery,
  useCurrentUserUnreadReadingListItemsQuery
} from '@interfaces/graphql-typings';

import ResearchItemLoading from '@buyside/components/presentation/ResearchItem/researchItemLoading';
import ReadingListIdeas from '@buyside/components/presentation/UserAccount/ReadingList/readingListIdeas';

import { validatePageParam } from '@buyside/util/numbers';

const ReadingListIdeasContainer: React.FC<{
  archivedPage: boolean;
}> = ({ archivedPage }): React.ReactElement => {
  const [searchParams] = useSearchParams();
  const page = validatePageParam(searchParams);

  const useReadingListQuery = archivedPage
    ? useCurrentUserArchivedReadingListItemsQuery
    : useCurrentUserUnreadReadingListItemsQuery;

  const { loading, data } = useReadingListQuery({
    variables: { page }
  });

  if (loading || !data?.currentUser) return <ResearchItemLoading times={3} narrow />;

  return <ReadingListIdeas archivedPage={archivedPage} currentUser={data.currentUser} />;
};

export default ReadingListIdeasContainer;
